import request from '@/utils/request'

export function getBanners(params) {
  return request({
    url: '/app/findBannerList',
    method: 'get',
    params,
  })
}

export function addBanner(data) {
  return request({
    url: '/app/createBanner',
    method: 'post',
    data,
  })
}

export function editBanner(data) {
  return request({
    url: '/app/updateBanner',
    method: 'post',
    data,
  })
}

export function delBanner(data) {
  return request({
    url: '/app/removeBanner',
    method: 'post',
    data,
  })
}

export function getArticles(params) {
  return request({
    url: '/app/findArticleList',
    method: 'get',
    params,
  })
}

export function addArticle(data) {
  return request({
    url: '/app/createArticle',
    method: 'post',
    data,
  })
}

export function editArticle(data) {
  return request({
    url: '/app/updateArticle',
    method: 'post',
    data,
  })
}

export function delArticle(data) {
  return request({
    url: '/app/removeArticle',
    method: 'post',
    data,
  })
}

export function getActives(params) {
  return request({
    url: '/app/findActiveList',
    method: 'get',
    params,
  })
}

export function addActive(data) {
  return request({
    url: '/app/createActive',
    method: 'post',
    data,
  })
}

export function editActive(data) {
  return request({
    url: '/app/updateActive',
    method: 'post',
    data,
  })
}

export function delActive(data) {
  return request({
    url: '/app/removeActive',
    method: 'post',
    data,
  })
}

export function getAnnouncementList(params) {
  return request({
    url: '/app/findAnnouncementList',
    method: 'get',
    params,
  })
}

export function addAnnouncement(data) {
  return request({
    url: '/app/createAnnouncement',
    method: 'post',
    data,
  })
}

export function editAnnouncement(data) {
  return request({
    url: '/app/updateAnnouncement',
    method: 'post',
    data,
  })
}

export function delAnnouncement(data) {
  return request({
    url: '/app/removeAnnouncement',
    method: 'post',
    data,
  })
}

//获取小程序码
//获取小程序码：get app/getCode,参数：path，//类似pages/index/index?agentId=xxx
export function getCode(params) {
  return request({
    url: '/app/getCode',
    method: 'get',
    params,
  })
}
